import { Component, OnInit } from '@angular/core';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { ClientService } from 'src/app/services/client/client.service';
import { Constants } from 'src/app/constants/constants';
import { DtReportModel } from 'src/app/models/datatable/dt_report.model';
import { ReportService } from 'src/app/services/report/report.service';


@Component({
  selector: 'modal-new-report',
  templateUrl: './modal-new-report.component.html',
  styleUrls: ['./modal-new-report.component.scss'],
})
export class ModalNewReportComponent implements OnInit {

  newReport: DtReportModel;
  nameError: boolean = false;
  organisationError: boolean = false;


  constructor(public appearanceService: AppearanceService,
    private reportService: ReportService, 
    public modalController: ModalController, public clientService: ClientService) {

  }


  ngOnInit() 
  {
    this.newReport = new DtReportModel();
    this.newReport.clientUid = this.clientService.getClientUid(),
    this.newReport.reportName = "";
    this.newReport.reportDescription = "";
    this.newReport.organisationUid = this.clientService.getOrganisationUid();
    this.newReport.organisationName = this.clientService.getOrganisationName();
  }


  ionViewWillEnter()
  {
    this.nameError = this.organisationError = false;
  }


  ionViewWillLeave()
  {

  }

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'NewReportModal');
  }


  createNewReport()
  {
    var errorFound = false;
    this.nameError = this.organisationError = false;

    if (this.newReport.reportName == "")
    {
      this.nameError = true;
      errorFound = true;
    }

    if (errorFound)
    {
      return;
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.reportService.createReport(this.newReport).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { reportCreated: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Report added.", Constants.TOAST_SUCCESS);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }
}
